import { Link } from "react-router-dom";
import { GraduationCap, ArrowLeft } from "@phosphor-icons/react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-[#F7F3EE]">
      <header className="border-b border-zinc-200 bg-white/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-2xl gradient-primary flex items-center justify-center">
              <GraduationCap size={18} color="white" weight="duotone" />
            </div>
            <div>
              <div className="font-heading font-black text-base leading-none">Caminhos</div>
              <div className="text-[10px] uppercase tracking-widest font-bold text-zinc-500">APP</div>
            </div>
          </Link>
          <Link to="/" className="text-sm text-[#1E5FFF] font-semibold flex items-center gap-1 hover:underline">
            <ArrowLeft size={14} /> Voltar
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-8 py-10 sm:py-16 space-y-6">
        <div>
          <div className="pill-badge bg-white text-[#1E5FFF] border border-[#1E5FFF]/20 mb-4">LGPD • Lei 13.709/2018</div>
          <h1 className="font-heading text-4xl sm:text-5xl font-black text-[#12143A] tracking-tight">Política de Privacidade</h1>
          <p className="text-sm text-zinc-500 mt-3">Última atualização: 5 de agosto de 2026 • Vigência imediata</p>
        </div>

        <div className="card-soft p-6 sm:p-8 space-y-6 text-[15px] leading-relaxed text-zinc-700">
          <Section title="1. Quem somos" >
            <p>
              A <b>Caminhos APP</b> é uma plataforma brasileira de acompanhamento de estudos onde professores oferecem
              tutoria personalizada durante a preparação para vestibulares e concursos. Somos o Controlador dos
              seus dados pessoais nos termos da Lei Geral de Proteção de Dados (Lei 13.709/2018 — "LGPD").
            </p>
            <p>
              <b>Contato do Encarregado (DPO)</b>: <a href="mailto:midiatecnointerativa@gmail.com" className="text-[#1E5FFF] underline">midiatecnointerativa@gmail.com</a>
            </p>
          </Section>

          <Section title="2. Dados que coletamos">
            <ul className="list-disc pl-5 space-y-2">
              <li><b>Cadastrais</b>: nome, email, senha (armazenada com hash bcrypt), papel (aluno / responsável / admin), série, objetivo de estudo.</li>
              <li><b>Vinculação familiar</b>: no perfil "Responsável", o email do aluno vinculado.</li>
              <li><b>Acadêmicos</b>: agenda de estudos, notas, planos de estudo, materiais consumidos, mensagens com o Tutor IA.</li>
              <li><b>Financeiros</b>: histórico de mensalidades e status de adimplência (registrado manualmente pelo admin).</li>
              <li><b>Técnicos</b>: cookies de sessão, endereço IP para logs de segurança, agente do navegador.</li>
              <li><b>Integrações opcionais</b>: quando um professor autoriza o Google Calendar, armazenamos tokens de acesso (criptografados e usados apenas para criar eventos com Google Meet).</li>
            </ul>
          </Section>

          <Section title="3. Bases legais e finalidades (Art. 7 LGPD)">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
                <th className="pb-2">Finalidade</th><th>Base legal</th>
              </tr></thead>
              <tbody className="[&>tr]:border-b [&>tr]:border-zinc-100 [&>tr>td]:py-2">
                <tr><td>Autenticação e uso da plataforma</td><td>Execução de contrato (Art. 7, V)</td></tr>
                <tr><td>Acompanhamento pedagógico e tutoria IA</td><td>Execução de contrato (Art. 7, V)</td></tr>
                <tr><td>Emissão de código 2FA por email</td><td>Legítimo interesse — segurança (Art. 7, IX)</td></tr>
                <tr><td>Cobrança e controle de acesso por adimplência</td><td>Execução de contrato (Art. 7, V)</td></tr>
                <tr><td>Analíticos e melhorias de UX</td><td>Consentimento (Art. 7, I) — banner LGPD</td></tr>
                <tr><td>Cumprimento de ordens judiciais</td><td>Obrigação legal (Art. 7, II)</td></tr>
              </tbody>
            </table>
          </Section>

          <Section title="4. Compartilhamento com terceiros">
            <p>Compartilhamos dados apenas com operadores essenciais ao funcionamento:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li><b>Google (Calendar/Meet)</b> — quando o professor autoriza, os dados do evento (título, horário, emails dos participantes) são enviados à API do Google.</li>
              <li><b>OpenAI / Google Gemini</b> — mensagens enviadas ao Tutor IA são processadas por esses provedores para gerar respostas. Não usamos os dados para treinamento.</li>
              <li><b>Provedor de email transacional</b> — para o envio do código 2FA.</li>
              <li><b>MongoDB Atlas</b> — armazenamento de banco de dados criptografado em repouso.</li>
            </ul>
            <p>Não vendemos dados. Não usamos para marketing sem seu consentimento.</p>
          </Section>

          <Section title="5. Dados de menores">
            <p>
              A plataforma pode ser usada por menores de 18 anos com autorização e supervisão dos pais/responsáveis (Art. 14 LGPD).
              O responsável tem acesso ao painel para acompanhar o desempenho e a agenda do estudante.
            </p>
          </Section>

          <Section title="6. Retenção">
            <p>
              Mantemos seus dados enquanto sua conta estiver ativa e por até <b>5 anos</b> após o encerramento, para fins
              fiscais e defesa em processos administrativos ou judiciais. Você pode solicitar a exclusão antecipada
              (veja a seção 7).
            </p>
          </Section>

          <Section title="7. Seus direitos como titular (Art. 18 LGPD)">
            <p>Você pode, a qualquer momento, exercer os direitos abaixo através do painel <Link to="/data-rights" className="text-[#1E5FFF] font-semibold underline">Meus Dados</Link>:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li><b>Confirmação e acesso</b>: baixe um arquivo JSON com todos os seus dados.</li>
              <li><b>Correção</b>: atualize dados incompletos ou desatualizados no seu perfil.</li>
              <li><b>Anonimização, bloqueio ou eliminação</b>: solicite a exclusão da conta.</li>
              <li><b>Portabilidade</b>: exportação em formato aberto (JSON).</li>
              <li><b>Revogação de consentimento</b>: gerencie cookies opcionais no banner LGPD.</li>
              <li><b>Reclamação à ANPD</b>: <a className="text-[#1E5FFF] underline" href="https://www.gov.br/anpd" target="_blank" rel="noreferrer">gov.br/anpd</a></li>
            </ul>
          </Section>

          <Section title="8. Segurança">
            <ul className="list-disc pl-5 space-y-2">
              <li>Senhas armazenadas com <b>bcrypt</b>; jamais em texto puro.</li>
              <li>Tokens de sessão via cookies <b>httpOnly + Secure + SameSite</b>.</li>
              <li>JWT com expiração de <b>30 min</b> por inatividade + <b>2FA por email</b> em contas admin.</li>
              <li>Transporte via <b>HTTPS/TLS</b> em toda a plataforma.</li>
            </ul>
          </Section>

          <Section title="9. Cookies">
            <p>Usamos apenas cookies essenciais (autenticação e segurança) por padrão. Cookies analíticos e de marketing
              exigem seu consentimento explícito no banner LGPD. Você pode revisar suas preferências a qualquer momento
              limpando o armazenamento local do navegador ou nos contatando.
            </p>
          </Section>

          <Section title="10. Atualizações desta política">
            <p>Podemos atualizar esta política para refletir mudanças legais ou operacionais. A data no topo indica a
              versão vigente. Alterações relevantes serão comunicadas por email ou aviso na plataforma.</p>
          </Section>
        </div>

        <div className="text-center text-xs text-zinc-500 py-8">
          Caminhos APP • CNPJ pendente de cadastro • Contato: <a href="mailto:midiatecnointerativa@gmail.com" className="text-[#1E5FFF] underline">midiatecnointerativa@gmail.com</a>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-2xl font-black text-[#12143A] mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
